// Servicio para manejar autenticación con Firebase
class FirebaseAuthService {
  constructor() {
    this.firebaseApiKey = 'AIzaSyCZtlAJo6dxv4MW6ep_xV0VTBfDq0VJEFo';
    this.baseUrl = 'https://identitytoolkit.googleapis.com/v1';
  }

  // Paso 1: Autenticar con email y password
  async signInWithPassword(email, password) {
    try {
      const response = await fetch(`${this.baseUrl}/accounts:signInWithPassword?key=${this.firebaseApiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          returnSecureToken: true,
          email: email,
          password: password,
          clientType: 'CLIENT_TYPE_WEB'
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error?.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: {
          idToken: data.idToken,
          refreshToken: data.refreshToken,
          localId: data.localId,
          email: data.email,
          displayName: data.displayName,
          profilePicture: data.profilePicture,
          expiresIn: data.expiresIn,
          registered: data.registered
        }
      };
    } catch (error) {
      console.error('Firebase signIn error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Paso 2: Verificar token de Firebase
  async lookupUser(idToken) {
    try {
      const response = await fetch(`${this.baseUrl}/accounts:lookup?key=${this.firebaseApiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idToken: idToken
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error?.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Firebase lookup error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

export default new FirebaseAuthService();
